import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';

import EsmsCard from '../../components/EsmsCard';
import Switch from '../../components/FormFields/Switch';

import { isAllowed } from '../../helpers/auth';
import { Permissions } from '../../helpers/permissions';
import { toggleScoring } from '../../actions/adminActions';
import { fetchCompanyInfo } from '../../actions/companyInfoActions';
import { debounce } from 'lodash';


import classes from './ScoringCard.module.css';


class ScoringCard extends Component {

    handleToggle = debounce(() => {
        const { currentCompany, toggleScoring } = this.props;
        toggleScoring(currentCompany);
    }, 500)

    handlePageRoute = () => {
        const { history } = this.props;

        history.push('/admin/scoring' + history.location.search);
    }

    render() {
        let { currentScopes, currentCompany, toggleScoringLoading } = this.props;

        return (
            <EsmsCard
                title="Scoring"
                imagePath="/assets/images/scoringFlat.svg"
            >
                <div className={classes.innerContainer}>
                    <div className={classes.rolesInfo}>
                        <span className={classes.label}>
                            Enabled
                        </span>
                        <div>
                            <Switch
                                checked={currentCompany.scoringEnabled}
                                onChange={this.handleToggle}
                                isLoading={toggleScoringLoading}
                            />
                        </div>
                    </div>
                    {
                        isAllowed(currentScopes, Permissions('adminFull')) &&
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={this.handlePageRoute}
                        >
                            Manage Scoring
                        </Button>
                    }
                </div>
            </EsmsCard>
        );
    }
}

const mapStateToProps = state => {
    return {
        currentScopes:        state.core.currentScopes,
        currentUser:          state.currentUser,
        currentCompany:       state.companyInfo,
        toggleScoringLoading: state.scoring.toggleScoringLoading
    };
};

const mapDispatchToProps = {
    toggleScoring,
    fetchCompanyInfo
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ScoringCard));

